import state from './moduleEnumState.js'
import mutations from './moduleEnumMutations.js'
import actions from './moduleEnumActions.js'
import getters from './moduleEnumGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
